import localforage from 'localforage'
import Api from '../core/Api'
import Offline from './Offline'

class Outil {
    static serialize(data) {
        let payload = {};

        payload.typeOutil = data.type_outil.id;
        payload.magasin = data.magasin;
        payload.marque = data.marque;
        payload.modele = data.modele;
        payload.numeroSerie = data.numero_serie;
        payload.reference = data.reference;
        payload.dateAchat = (data.date_achat !== null && data.date_achat !== '') ? moment(data.date_achat).format('YYYY-MM-DD') : null;
        payload.factureAchat = data.facture_achat;
        payload.bonLivraison = data.bon_livraison;
        payload.dateLastControle = moment(data.date_last_controle).format('YYYY-MM-DD');
        payload.actif = data.actif;

        return payload;
    }

    static async addOutilOnline(data) {
        return new Promise((resolve, reject) => {
            let payload = this.serialize(data);

            Api
                .init()
                .then(api => {

                    api
                        .post('/outil', payload)
                        .then(result => {

                            if (!result.data.errors) {
                                resolve(result.data)
                            } else {
                                reject(result.data.errors)
                            }
                        })
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    static async addOutilOffline(data) {
        let tempId = 'N-' + +new Date();
        let outils = await Outil.getList();

        data.id = tempId;
        outils.push(data);

        await localforage.setItem('listOutils', JSON.stringify(outils));

        await Offline.saveAction({
            action: 'add',
            type: 'Outil',
            id: tempId
        });

        if (data.type_outil.nom === "Détecteur de fuites manuel") {
            await Outil.disableDetecteursExcept(tempId);
        }

        return true;
    }

    static updateOffline(id, data, callback) {

        if (!_.includes(id, 'N-')) {
            id = parseInt(id)
        }

        this
            .getList()
            .then(lstOutils => {

                let index = _.findIndex(lstOutils, ['id', id]);

                if (index === -1) {
                    if (typeof callback === 'function') callback('Outil introuvable')
                    return;
                }

                lstOutils[index] = data;

                localforage
                    .setItem('listOutils', JSON.stringify(lstOutils))
                    .then(() => {

                        Offline.saveAction({
                            action: 'update',
                            type: 'Outil',
                            id: id
                        });

                        if (typeof callback === 'function') callback('Update offline ok')
                    })
                    .catch(err => {
                        if (typeof callback === 'function') callback(err)
                    })

            })
            .catch(err => {
                if (typeof callback === 'function') callback(err)
            })

    }

    static async updateOnline(data) {
        return new Promise((resolve, reject) => {
            let idOutil = data.id;
            let payload = this.serialize(data);

            Api
                .init()
                .then(api => {

                    api
                        .put('/outil/' + idOutil, payload)
                        .then(res => {

                            if (!res.data.hasOwnProperty('errors')) {

                                Offline
                                    .deleteAction(idOutil, 'Outil')
                                    .then(() => {
                                        resolve(true)
                                    })
                                    .catch(err => {
                                        if (err.response && (err.response.status === 403 || err.response.status === 404)){
                                            resolve(true)
                                        } else {
                                            reject(err)
                                        }
                                    })

                            } else {

                                reject(res.data.errors)

                            }

                        })
                        .catch(err => reject(err))


                })
                .catch(err => reject(err))

        })

    }

    static async disableDetecteursExcept(id) {

        let outils = await Outil.getList();

        let arrayToUpdt = [];

        let newList = _.map(outils, o => {

            if (o.type_outil.nom === 'Détecteur de fuites manuel') {

                arrayToUpdt.push(o.id);

                if (o.id !== id) {
                    o.actif = false
                } else {
                    o.actif = true
                }

            }

            return o;

        });

        await localforage.setItem('listOutils', JSON.stringify(newList));
        for (let outil in arrayToUpdt) {
            await Offline.saveAction({action: 'update', type: 'Outil', id: arrayToUpdt[outil]})
        }

        return true

    }

    static getDetecteurActif() {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let detec = _.filter(data, outil => {
                        if (outil.actif === true && outil.type_outil.nom === "Détecteur de fuites manuel") {
                            return outil
                        }
                    });

                    if (detec.length === 1) {

                        let outil = detec[0];
                        let ctrl = moment(outil.date_last_controle);
                        let today = moment();
                        let diff = today.diff(ctrl, 'month', true);

                        if (diff < 12) {
                            resolve(outil)
                        } else {
                            reject('Le détecteur actif doit être contrôlé')
                        }

                    } else {
                        reject('Aucun détecteur de fuites manuel actif')
                    }

                })
                .catch(err => reject(err))

        })

    }

    static async getOutil(id) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(res => {

                    if (!_.includes(id, 'N-')) {
                        id = parseInt(id)
                    }

                    let outil = _.find(res, ['id', id]);

                    if (outil) {
                        resolve(outil)
                    } else {
                        reject('Outil inexistant')
                    }
                })
                .catch(err => reject(err))

        })
    }

    static getList() {

        return new Promise((resolve, reject) => {
            localforage
                .getItem('listOutils')
                .then(outils => {
                    const parsed = JSON.parse(outils);
                    resolve(Array.isArray(parsed) ? parsed : [])
                })
                .catch(error => {
                    reject(error)
                })
        })

    }

    static getTypes() {

        return new Promise((resolve, reject) => {
            localforage
                .getItem('listTypesOutil')
                .then(types => {
                    resolve(JSON.parse(types))
                })
                .catch(error => {
                    reject(error)
                })
        })

    }

    static getWarningOutils() {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let filtred = _.filter(data, outil => {

                        let dateCtrl = moment(outil.date_last_controle);
                        let today = moment();
                        let diff = today.diff(dateCtrl, 'month', true);

                        if (diff <= 12 && diff >= 11 && outil.actif) {
                            outil.type_notif = 'warning';
                            outil.date_butoir = dateCtrl.add(1, 'year');
                            return outil
                        }
                    });

                    resolve(filtred)

                })
                .catch(err => reject(err))

        })

    }

    static getErrorsOutils() {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {

                    let filtred = _.filter(data, outil => {

                        let dateCtrl = moment(outil.date_last_controle);
                        let today = moment();
                        let diff = today.diff(dateCtrl, 'month', true);

                        if (diff > 12 && outil.actif) {
                            outil.type_notif = 'error';
                            outil.date_butoir = dateCtrl.add(1, 'year');
                            return outil
                        }
                    });

                    resolve(filtred)

                })
                .catch(err => reject(err))
        })
    }
}

export default Outil



// WEBPACK FOOTER //
// ./src/js/models/Outil.js